import { http, get, post, req } from '@/plugins/axios'
import { blankBar } from '@/util/useFormat'
/**
 * 查询平台订单分页（前台）
 * @param {Object} data
 */
export function getPlatformOrder (data: any) {
  return post('/order/customer/platformOrder/page', data).format((data: any) =>
    blankBar(data.records)
  )
}

/**
 * D2c平台订单详情
 * @param {Object} params
 */
export function getPlatformOrderDetail (params: any) {
  return get('/order/customer/platformOrder/detail', { params }).format(
    blankBar
  )
}

/**
 * D2c平台订单详情
 * @param {Object} params
 */
export function getB2bPlatformOrderDetail (params: any) {
  return get('/order/customer/platformOrder/b2bPlatformOrderDetail', { params })
}

/**
 * 结算费用详情
 * @param {Object} params
 */
export function getBillingFeeDetails (params: any) {
  return get('/order/customer/platformOrder/billingFeeDetails', { params })
}

/**
 * 查询平台订单详情列表
 * @param {Object} params
 */
export function getPlatformOrderItem (params: any) {
  return get('/order/customer/platformOrderItem/list', { params }).format(
    blankBar
  )
}

export function getPlatformOrderItemPage (params: any) {
  return get('/order/customer/platformOrderItem/page', { params }).format(
    blankBar
  )
}

/**
 * 查询平台订单详情列表
 * @param {Object} params
 */
export function getPlatformOrderItemSearch (data: any) {
  return post('/order/customer/platformOrderItem/search', data).format(
    blankBar
  )
}

/**
 * 查询平台订单详情列表
 * @param {Object} params
 */
export function postPlatformOrderPay (data: any) {
  return post('/order/customer/platformOrder/pay', data)
}

/**
 * 分页列表异常订单
 * @param {Object} data
 */
export function pageAbnormalOrder (data: any) {
  return post('/order/abnormalOrder/pageAbnormalOrder', data)
}

/**
 * 分页列表异常订单
 * @param {Object} data
 */
export function queryAbnormalOrder (data: any) {
  return post('/purchase/user/purchase/abnormal/queryAbnormal', data)
}
/**
 * 获取异常订单数量等
 * @param {Object} params
 */
export function countAbnormalOrderCount (params: any) {
  return get('/order/abnormalOrder/countAbnormalOrderCount', { params })
}

/**
 * 后台：根据商品编码获取商品详情
 * @param {Object} params
 */
export function backendProduct (params: any) {
  return get('/goods/product/detail/backend', { params })
}

/**
 * 后台: 根据单个sku获取商品详情; 没有任何限制
 * @param {Object} params
 */
export function backendProductSku (params: any) {
  return get('/goods/product/detail/backend/byProductSku', { params })
}

/**
 * 根据url搜索商品-全部接口
 * @param {Object} params
 */
export function searchAll (data: any) {
  return post('/goods/search/url/all', data)
}
/**
 * 申请取消校验
 * @param {Object} data
 */
export function applyCancelCheck (data: any) {
  return post('/order/customer/platformOrder/applyCancelCheck', data)
}

/**
 * 问题处理
 * @param {Object} data
 */
export function problemHandling (data: any) {
  return post('/purchase/user/purchase/abnormal/handleAbnormal', data)
}

/**
 * 售后处理
 * @param {Object} data
 */
export function afterSalesHandling (data: any) {
  return post('/order/abnormalOrder/afterSalesHandling', data)
}

/**
 * 查询订单组合商品-组合详情
 * @param {Object} data
 */
export function combinationInfo (params: any) {
  return get('/order/customer/platformOrderItem/combinationInfo', { params })
}

/**
 * 用户申请取消
 * @param {Object} data
 */
export function userApplyCancel (data: any) {
  return post('/order/customer/platformOrder/userApplyCancel', data)
}

/**
 * 优先发货
 * @param {Object} data
 */
export function priorityShipping (data: any) {
  return post('/order/customer/platformOrder/priorityShipping', data)
}

/**
 * 修改地址
 * @param {Object} data
 */
export function updateShippingAddress (data: any) {
  return post('/order/platformOrderDeliverAddress/updateShippingAddress', data)
}

/**
 * 商品详情
 * @param {Object} data
 */
export function ordeProductDetails (data: any) {
  return post('/order/customer/platformOrderItem/productDetails', data).format(
    (data: any) => {
      if (!data.customerProductInfo) {
        data.customerProductInfo = {
          apiShopProductSku: '-',
          apiShopProductTitle: '-',
          apiShopProductPropertiesName: '-'
        }
      }
      blankBar(data)
    }
  )
}

/**
 * 国际物流信息详情
 * @param {Object} params
 */
export function inLogInfoDetail (params: any) {
  return get(
    '/order/customer/platformOrder/listInternationalityLogisticsInfoDetail',
    { params }
  )
}

/**
 * 复购/加购
 * @param {Object} data
 */
export function orderRepurchase (data: any) {
  return post('/order/customer/platformOrder/repurchase', data)
}

/**
 * 取得用户店铺
 */
export function getCustomerShop (a?:any) {
  return post('/customer/customer/shop/get', a)
}

/**
 * 手动同步客户店铺的订单
 * @param {Object} data
 */
interface FSOD{
  startTime:string,
  endTime:string
}
export function syncOrder (data: FSOD) {
  return post('/api/thirdShopOrder/manualSyncOrder', data)
}

/**
 * 已同步的店铺订单列表
 * @param {Object} data
 */
interface SOD{
  shopOrderId?:number
  shopOrderIds?:number[]
  orderName?: string
  orderNames?: string[]
  shopOrderStartTime?:string
  shopOrderEndTime?:string
  orderSyncStatus?:number
  pageNum?:number
  pageSize?:number
}
export function pageSyncOrderList (data: SOD) {
  return post('/api/thirdShopOrder/queryShopOrder', data).then((res) => {
    res.data.records = res.data.records.map((item:any) => {
      return {
        ...item,
        intShipConfigCn: item.intShipConfigList?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'CN') ?? {},
        intShipConfigJp: item.intShipConfigList?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'JP') ?? {},
        intShipConfigKr: item.intShipConfigList?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'KR') ?? {},
        deliveryAdditionJp: item.deliveryAdditions?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'JP') ?? {},
        deliveryAdditionCn: item.deliveryAdditions?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'CN') ?? {},
        deliveryAdditionKr: item.deliveryAdditions?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'KR') ?? {}
      }
    })
    console.log(res, 'queryShopOrder')

    return res
  })
}

/**
 * 授权店铺-下单（单个/批量）
 */
interface CSOD{
  shopOrderIds:(number|string)[]
}
interface CreateShopOrder extends CSOD {
    useOneTheWayInventory?: boolean
  }
export function createShopOrder (data: CreateShopOrder) {
  return post('/api/thirdShopOrder/createPlatformOrders', data)
}

/**
 * 授权店铺-删除订单
 */
export function deleteShopOrder (data: CSOD) {
  return post('/api/thirdShopOrder/deleteShopOrder', data)
}

/**
 * 更新订单-国际物流单号回传开关
 * @param {Object} data
 */
export function updateSynLogisticsNoApi (data: any) {
  return req('/api/thirdShopOrder/updateSynLogisticsNo', data)
}

/**
 * 店铺订单编辑附加项
 */
export function editDeliveryAdditions (data: any) {
  return post('/api/thirdShopOrder/editDeliveryAdditions', data)
}

/**
 * 更新店铺订单信息-收货地址
 */
export function updateShopOrderAddress (data: any) {
  return post('/api/thirdShopOrder/updateShopOrderAddress', data)
}

/**
 * 查询某个店铺订单内的商品
 */
export function getShopOrderProductList (params: any) {
  return get('/api/thirdShopOrder/getShopOrderItemList', { params })
}

/**
 * 删除某个店铺订单内的商品
 */
export function delShopOrderProduct (data: any) {
  return post('/api/thirdShopOrder/deleteShopOrderItem', data)
}

/**
 * 删除商品
 */
export function delProduct (data: any) {
  return post('/api/amazon/product/remove', data)
}

/**
 * 分页查询
 * @param {Object} data
 */
export function amazonPage (data: any) {
  return post('/api/amazon/product/page', data)
}

/**
 * 异常订单查询字段
 * @param {Object} data
 */
export function getUserPurchaseAbnormalExtentApi (data: any) {
  return post('/purchase/purchase/abnormal/getUserPurchaseAbnormalExtent', data)
}

/**
 * 异常订单查询PDD
 * @param {Object} data
 */
export function getUserPurchaseAbnormalPdd (data: any) {
  return post('purchase/purchase/abnormal/getUserPurchaseAbnormalPdd', data)
}

/**
 * 异常订单详情
 * @param {Object} data
 */
export function getAbnormalDetailApi (params: any) {
  return get('/purchase/user/purchase/abnormal/info', { params })
}
/**
 * 订单 api修改状态
 * @param {Object} data
 */
export function updateOrderSynLogisticsNoApi (data: any) {
  return post('/order/customer/platformOrder/updateSynLogisticsNo', data)
}

/**
 * 不再二次确认说明
 * @param data
 * @returns
 */
export function splitRemindFlagApi (data: any) {
  return post('/customer/splitRemindFlag', data)
}

/**
 * 是否可修改收货地址
 * @param data
 * @returns
 */
export function getOrderEditAddressApi (params: any) {
  return get('/wms/delivery/task/enableUpdateAddr', { params })
}

/**
 * 是否可修改收货地址
 * @param data
 * @returns
 */
export function getOrderEditAddressOverseasApi (params: any) {
  return get('/overseas-wms/delivery/task/enableUpdateAddr', { params })
}

/**
 *
 */
export const reportPerformance = (json:any):any => {
  return post('/order/log/vueLog', json)
}

/**
 * 查询订单数量接口
 * @param data
 * @returns
 */
export const getOrderNumberApi = () => {
  return post('/order/excel/queryCount')
}

// 确定订单详情
export const confirmOrderDetailApi = (data: {platformOrderIds:string[]}): any =>
  post('/order/excel/orderDetails', data)

// 编辑发货附加项接口
export const editDeliveryAdditionsApi = (data: any): any =>
  post('/order/excel/editDeliveryAdditions', data)

// 编辑国际物流接口
export const editIntShipApi = (data: any): any =>
  post('/order/excel/editIntShip', data)

// 编辑商品附加项接口
export const editOrderGoodsAdditionApi = (data: any): any =>
  post('/order/excel/batchEditItemAdditions', data)

// 每个tab订单数量
export const getEveryOrderNumberApi = (data: any): any =>
  post('/order/excel/queryCount', data)

// 订单拦截
export const configDeliveryIntercept = (data: any): any =>
  post('/order/customer/platformOrder/configDeliveryIntercept', data)
// api编辑附加项
export const apiEditAdditionApi = (data: any): any =>
  post('/api/thirdShopOrder/updateOrderItemAddition', data)

// 查询组合子商品附加项
export const batchQueryCombinationProduct = (data: any): any =>
  post('/order/combination/product/listByCombinationProductSku', data)

/**
 * 获取物流信息
 * @param data
 * @returns
 */
export function getOrderExpressListApi (params: any) {
  return get('/order/customer/platformOrderItem/queryItemExpressInfo', { params })
}

/**
 * 查询跟单记录
 * @param data
 * @returns
 */
export function queryUserMerchandiser (data: any) {
  return post('/purchase/merchandiser/queryUserMerchandiser', data)
}

// 是否展示shopify
export const isShowShopifyTitleApi = (): any =>
  post('/order/customer/platformOrder/querySubscriptionShopify', {})

// api订单数量
export const getApiOrderCountApi = (): any =>
  get('/api/thirdShopOrder/queryCount', {})

// 订单详情资金明细展示
export const getOrderDetailFundListApi = (params:any): any =>
  get('/settlement/wallet/getFundDetailByPlatformOrderNo', { params })

/** 异常订单-待确认-sku、整单查询分页接口 */
export function pageDeliveryAbnormalOrder (data: any) {
  return post('/order/abnormalOrder/pageDeliveryAbnormalOrder', data)
}
/** 异常订单-待确认-数量统计 */
export function countDeliveryAbnormalOrderCount (data: any) {
  return get('/order/abnormalOrder/countDeliveryAbnormalOrderCount', data)
}

/** 异常订单-待确认-sku、整单问题处理接口 */
export function processAbnormalDeliveryOrder (data: any) {
  return post('/order/abnormalOrder/processAbnormalDeliveryOrder', data)
}
// 订单列表-分期支付
export const partPayApi = (data: any): any =>
  post('/order/customer/platformOrder/partPay', data)

export function shopOrderCount (params: any) {
  return get('/order/customer/platformOrder/shopOrderCount', { params })
}

// 韩国站提示弹窗
export function getIsShowCustomsApi (params: any) {
  return get('/order/cart/getClearanceReminder', { params })
}

// 弹窗展示时间
export const customsShowTimeApi = (data: any): any =>
  post('/order/cart/markClearanceReminder', data)

// 批量一键追踪设置
export const batchUpdateSyncLogisticsApi = (data: any): any =>
  post('/api/thirdShopOrder/batchUpdateSyncLogisticsNo', data)

// 编辑订单标题
export const editCustomerNoApi = (data: any): any =>
  post('/order/customer/platformOrder/updateCustomerOrderNo', data)

// 获取2c订单金额上限
export const getD2cMoneyApi = (params: any): any =>
  get('/order/cart/getD2CDirectOrderAmountLimit', { params })

/** 批量优先发货 */
export const batchPriorityShipping = (data: any): any =>
  post('/order/customer/platformOrder/batchPriorityShipping', data)

/** 购物车在途库存列表 */
export const pageOrderOnTheWayStockApi = (data: any): any =>
  post('/order/shop/product/sku/pageOnTheWayStock', data)
/** 购物车在途库存是否有 */
export const hasOrderAvailableTransportationNums = (data: any): any =>
  post('order/shop/product/sku/hasAvailableTransportationNums', data)
// 获取商品黑名单属性
export const getOrderGoodsDetailApi = (data: any): any =>
  post('/goods/product/spu/black', data)
  /** 判断是否可以进行批量优先发货 */
export const existPriorityShippingJobApi = (): any =>
  get('order/customer/platformOrder/existPriorityShippingJob')

/** 新增或编辑标签模板 */
export const saveTemplate = (data: any): any =>
  post('/order/delivery/tag/saveTemplate', data)

/** 获取店铺配置的标签模板 */
export const getTemplate = (params: any): any =>
  get('/order/delivery/tag/getTemplate', { params })

/** 获取店铺默认的标签模板 */
export const getDefaultTemplate = (params: any): any =>
  get('/order/delivery/tag/getDefaultTemplate', { params })

/** 导出Excel */
export const zozotownExcelExport = (params: any): any =>
  get('/order/delivery/tag/excelExport', {
    responseType: 'arraybuffer',
    params
  })

/** 批量编辑客户店铺sku的标签内容 */
export const batchEditTagContent = (data: any): any =>
  post('/order/shop/product/sku/batchEditTagContent', data)

/** 根据sku获取水洗标列表和规格 */
export const getSkuWashInfoApi = (data: any): any =>
  post('/order/shop/product/sku/getWashedlabelList', data)

/** 异常订单-问题处理列表(按系统单号分组) */
export const abnormalQueryGroup = (data: any): any =>
  post('/purchase/user/purchase/abnormal/queryGroup', data)
/** 获取api订单白名单用户 */
export const getMissingItemOrderFlagApi = (params: any): any =>
  get('/api/thirdShopOrder/getMissingItemOrderFlag', { params })

export const intShipConfigGetForwarders = (intShipConfigId:string): any =>
  get(`/settlement/intShipConfig/getForwarders?intShipConfigId=${intShipConfigId}`)

// 查询系统取消的订单
export const querySystemCancelOrder = (): any =>
  post('/order/abnormalOrder/querySystemCancelOrder')

interface handleSystemCancelOrderProps{
  abnormalOrderIds:string[]
}

export interface CancelOrderProps {
  productSkuImg?: string
  productSku?: string
  /** 取消原因 */
  processManner?: number
  abnormalOrderId?: string
  /** 被取消数量 */
  cancelQuantity?:number
  platformOrderNo?:string
  productMainImg?:string
}

// 系统取消订单标记为已查看
export const handleSystemCancelOrder = (data: handleSystemCancelOrderProps): any =>
  post('/order/abnormalOrder/handleSystemCancelOrder', data)

// 待支付修改运输方式
export const editTransportTypeApi = (data:any): any =>
  post('/order/excel/editTransportType', data)

// FBA创建补货计划(导入excel)
export const shippingImportSkuApi = (data:any): any =>
  post('/order/shop/product/sku/importSku', data)

// 批量编辑组合子商品附加项
export const subAdditionBatchEditApi = (data:any): any =>
  post('/order/combination/product/subAdditionBatchEdit', data)

// 工作台智能补货待支付列表弹窗数据
export const getRestockWaitPayApi = (data:any): any =>
  post('/order/customer/platformOrder/queryWaitReplenishItems', data)

// 补货单统计
export const getRestockTotalNumberApi = (data?:any): any =>
  req('/order/customer/replenishOrder/statistics', data)

// 导出补货单平台明细
export const exportPlatformItemListApi = (params: any) => get('/order/customer/replenishOrder/exportPlatformItemList', {
  responseType: 'arraybuffer',
  params
})

// api待补货订单列表

export const queryWaitReplenishShopOrderApi = (data?:any): any =>
  post('/api/thirdShopOrder/queryWaitReplenishShopOrder', data)

// api待补货订单明细

export const getWaitReplenishShopOrderItemListApi = (data?:any): any =>
  req('/api/thirdShopOrder/getWaitReplenishShopOrderItemList', data)

// 引当管理 新增商品
export const saveOrUpdateShopProductSkuApi = (data?:any): any =>
  post('/order/foreign/shop/product/sku/saveOrUpdateShopProductSku', data)

// 获取商品信息详情
export const getSkuDetailApi = (data?:any): any =>
  req('/order/foreign/shop/product/sku/detail', data)

// 导入记录查询
export const getExcelFileHistoryApi = (data?:any): any =>
  post('/order/excel/page', data)
// 日本品采购计划详情

export const getReplenishOrderDetailApi = (data?:any): any =>
  req('/order/customer/replenishOrder/detail', data)

// 查询sku采购未使用数量

export const getQueryPurchaseUnuseQuantityApi = (data?:any): any =>
  req('/order/customer/replenishOrder/queryPurchaseUnuseQuantity', data)

// 日本品采购计划编辑

export const editPlatformItemApi = (data?:any): any =>
  post('/order/customer/replenishOrder/editPlatformItem', data)

export const pageQueryPlatformItemListApi = (data?:any): any =>
  post('/order/customer/replenishOrder/pageQueryPlatformItemList', data)

export const queryActualPurchaseQuantityApi = (data?:any): any =>
  post('/order/customer/replenishOrder/queryActualPurchaseQuantity', data)

// 查询sku采购未使用数量

export const updateMappingSkuStatusApi = (data?:any): any =>
  req('/api/thirdShopItemSku/updateMappingSkuStatus', data)

// 3rd新增组合商品查询sku信息
export const get3rdProoductSkuSearchApi = (data?:any): any =>
  post('/order/shop/product/sku/pageMyshopAllProduct', data)

// 编辑取消数量
export const editCancelQuantityApi = (data?:any): any =>
  post('/order/customer/replenishOrder/editCancelQuantity', data)

// 获取异常数据信息
export const getAbnormalListApi = (data?:any): any =>
  post('/purchase/user/purchase/abnormal/exportAbnormalDetail', data)
